import {
  AutocompleteFilterStrategy,
  AutocompleteFilterType,
  AutocompleteProperty,
} from '../enums';
import ControlProps from '../../../mixins/ControlProps';
import { SelectProperty } from '../../select/enums';
import SelectProps from '../../select/mixins/SelectProps';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';

const AutocompleteProps = {
  props: {
    ...ControlProps.props,
    [AutocompleteProperty.IsLoading]: InputProps.props[InputProperty.IsLoading],
    [AutocompleteProperty.FillType]: InputProps.props[InputProperty.FillType],
    [AutocompleteProperty.Options]: SelectProps.props[SelectProperty.Options],
    [AutocompleteProperty.Multiple]: SelectProps.props[SelectProperty.Multiple],
    [AutocompleteProperty.NoValueOption]: SelectProps.props[SelectProperty.NoValueOption],
    [AutocompleteProperty.SearchHandler]: {
      default: () => () => {},
      type: Function,
    },
    [AutocompleteProperty.FilterStrategy]: {
      type: String,
      default: AutocompleteFilterStrategy.Sync,
    },
    [AutocompleteProperty.FilterType]: {
      type: String,
      default: AutocompleteFilterType.Includes,
    },
  },
};

export default AutocompleteProps;
